import RelationsTable from 'dashboard/components/RelationsTable';
import { ModuleRelations } from 'dashboard/modules/Relations/model';
import { AccountState } from 'dashboard/redux/slices/account';
import Card from 'design-system/components/Card';
import { Paragraph } from 'design-system/components/Text';

export interface RelationsProps {
  relations?: AccountState['relations'];
  module: ModuleRelations;
}

const Relations = ({ relations = {}, module }: RelationsProps) => {
  return (
    <Card data-test={`module__relations--${module.token}`}>
      <Card.Body>
        <Card.Title>Relations</Card.Title>
        {Object.keys(relations).length > 0 ? (
          <RelationsTable relations={relations} />
        ) : (
          <Paragraph color='tertiary'>
            There are no relations set up on this account type.
          </Paragraph>
        )}
      </Card.Body>
    </Card>
  );
};

export default Relations;
